module.exports = "https://web-assets.ifttt.com/packs/media/stencils/push-notification-b19f8173.svg";